import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div<{
  $selectedWidth?: number;
  $selectedOffset?: number;
  $isFullWidth: boolean;
  $preventDrag: boolean;
  $hasDarkBackground: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;

  padding: ${({ theme }) => theme.spacing(0.5)};
  width: ${({ $isFullWidth }) => ($isFullWidth ? '100%' : 'auto')};

  border-radius: ${({ theme }) => theme.spacing(2)};
  background: ${({ theme, $hasDarkBackground }) =>
    theme.palette.grey[$hasDarkBackground ? 300 : 100]};

  color: ${({ theme }) => theme.palette.text.primary};

  ${({ theme, $selectedWidth, $selectedOffset }) =>
    $selectedWidth &&
    $selectedOffset &&
    css`
      &:before {
        content: '';
        position: absolute;
        top: ${theme.spacing(0.5)};

        height: calc(100% - ${theme.spacing(1)});
        width: ${$selectedWidth}px;

        transform: translateX(
          calc(${$selectedOffset}px - ${theme.spacing(0.5)})
        );
        background: ${({ theme }) => theme.palette.background.default};
        border-radius: ${({ theme }) => theme.spacing(1.5)};
        box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
        transition:
          transform 200ms ease-in-out,
          width 200ms ease-in-out;
      }
    `}

  ${({ $preventDrag }) =>
    $preventDrag &&
    css`
      -webkit-app-region: no-drag;
    `};
`;

export const Divider = styled.div`
  min-width: 1px;
  width: 1px;
  height: 1.2rem;

  margin: ${({ theme }) => `0 ${theme.spacing(2)}`};
  background: ${({ theme }) => theme.palette.divider};
`;

export const Button = styled.button<{ $selected: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  position: relative;
  height: 2.2rem;
  min-width: 3.2rem;
  width: 100%;

  margin: 0;
  padding: ${({ theme }) => `0 ${theme.spacing(2)}`};

  cursor: pointer;
  border: none;
  background: transparent;
  transition: color 200ms ease-in-out;

  color: ${({ theme, $selected }) =>
    $selected ? theme.palette.text.primary : theme.palette.grey[700]};

  &:hover {
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;

export const IconContainer = styled.span`
  display: block;
  font-size: 1.4rem;
  line-height: 62.5%;
`;
